// Finds dropdown class and adds open class to it
class Dropdown {
    constructor() {
        this.setupEvents();
    }

    setupEvents() {
        var $dropdown = jQuery('.dropdown');

        if ($dropdown.length > 0) {
            $dropdown.find('button, .dropdown-button').on('click', function () {
                var $this = jQuery(this);
                var $parent = $this.parent('.dropdown');

                $parent.toggleClass('open');
            });
        }

        jQuery('.dropdown-container').on('click', function () {
            jQuery(this).toggleClass('open')
        })
    }
}

export default Dropdown;
